import { ReactNode } from 'react'

interface InfoCardProps {
  rows: ReactNode[][]
  className?: string
}

export const InfoCard = ({ rows, className }: InfoCardProps) => {
  const maxCols = Math.max(...rows.map(r => r.length), 1)

  return (
    <div className={`p-4 bg-muted/30 rounded-xl border border-border/50 ${className}`}>
      {rows.map((row, ri) => (
        <div key={ri} className={ri > 0 ? 'mt-4 pt-4 border-t border-border/50' : ''}>
          <div className="grid" style={{ gridTemplateColumns: `repeat(${maxCols}, minmax(0, 1fr))`, gap: '1.25rem' }}>
            {row.map((item, ci) => (
              <div key={ci} className={ci > 0 ? 'border-l pl-5 border-border/90' : ''}>
                {item}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
